import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { blsUsersResult } from '../../../models/users-models/bls-users-result';
import { blsUser } from '../../../models/users-models/blsUser';
import { EditUserPayload } from '../../../models/users-models/edit-user.payload';
import { UserPayload } from '../../../models/users-models/user.payload';

export const UsersActions = createActionGroup({
  source: 'USERS',
  events: {
    getUsers: emptyProps(),
    getUsersSuccess: props<{ usersResult: blsUsersResult }>(),
    updateBlsUsersLoading: props<{ blsUsersLoading: boolean }>()
  }
});

export const UserActions = createActionGroup({
  source: 'USERS - SINGLE USER',
  events: {
    createUser: props<{ userParams: UserPayload | EditUserPayload, editMode: boolean }>(),
    userCreated: props<{ user: blsUser }>(),
    userDeleted: props<{ userId: number }>(),
  }
});

export const beError = createAction('[USERS] BE Error',
    props<{ error: HttpErrorResponse, userFriendlyMessage: string }>());
export const usersComponentDestroyed = createAction('[USERS] Component destroyed');

export const updateFilterModel = createAction('[USERS] update filterModel',
    props<{ filterModel: { [key: string]: any } }>());
